/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getMensesEvents } from 'app/entities/menses-event/menses-event.reducer';
import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { PregnancySight } from 'app/shared/model/enumerations/pregnancy-sight.model';
import { createEntity, getEntity, reset, updateEntity } from './pregnancy-case.reducer';

export const PregnancyCaseUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const mensesEvents = useAppSelector(state => state.mensesEvent.entities);
  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const pregnancyCaseEntity = useAppSelector(state => state.pregnancyCase.entity);
  const loading = useAppSelector(state => state.pregnancyCase.loading);
  const updating = useAppSelector(state => state.pregnancyCase.updating);
  const updateSuccess = useAppSelector(state => state.pregnancyCase.updateSuccess);
  const pregnancySightValues = Object.keys(PregnancySight);

  const handleClose = () => {
    navigate(`/pregnancy-case${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getMensesEvents({}));
    dispatch(getGlucoUsers({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.lmp !== undefined && typeof values.lmp !== 'number') {
      values.lmp = Number(values.lmp);
    }
    if (values.expectedDueDate !== undefined && typeof values.expectedDueDate !== 'number') {
      values.expectedDueDate = Number(values.expectedDueDate);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...pregnancyCaseEntity,
      ...values,
      event: mensesEvents.find(it => it.id.toString() === values.event?.toString()),
      patient: glucoUsers.find(it => it.id.toString() === values.patient?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          pregnancySight: 'NORMAL',
          ...pregnancyCaseEntity,
          event: pregnancyCaseEntity?.event?.id,
          patient: pregnancyCaseEntity?.patient?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.pregnancyCase.home.createOrEditLabel" data-cy="PregnancyCaseCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.pregnancyCase.home.createOrEditLabel">Create or edit a PregnancyCase</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pregnancy-case-id"
                  label={translate('tinyMedicRestApp.pregnancyCase.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pregnancyCase.lmp')}
                id="pregnancy-case-lmp"
                name="lmp"
                data-cy="lmp"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pregnancyCase.expectedDueDate')}
                id="pregnancy-case-expectedDueDate"
                name="expectedDueDate"
                data-cy="expectedDueDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pregnancyCase.deliveryStatus')}
                id="pregnancy-case-deliveryStatus"
                name="deliveryStatus"
                data-cy="deliveryStatus"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pregnancyCase.pregnancyResult')}
                id="pregnancy-case-pregnancyResult"
                name="pregnancyResult"
                data-cy="pregnancyResult"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pregnancyCase.pregnancySight')}
                id="pregnancy-case-pregnancySight"
                name="pregnancySight"
                data-cy="pregnancySight"
                type="select"
              >
                {pregnancySightValues.map(pregnancySight => (
                  <option value={pregnancySight} key={pregnancySight}>
                    {translate(`tinyMedicRestApp.PregnancySight.${pregnancySight}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pregnancyCase.active')}
                id="pregnancy-case-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pregnancyCase.draft')}
                id="pregnancy-case-draft"
                name="draft"
                data-cy="draft"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pregnancyCase.cursor')}
                id="pregnancy-case-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pregnancyCase.lastUpdated')}
                id="pregnancy-case-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pregnancyCase.microSec')}
                id="pregnancy-case-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pregnancyCase.timestampEntry')}
                id="pregnancy-case-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                id="pregnancy-case-event"
                name="event"
                data-cy="event"
                label={translate('tinyMedicRestApp.pregnancyCase.event')}
                type="select"
              >
                <option value="" key="0" />
                {mensesEvents
                  ? mensesEvents.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pregnancy-case-patient"
                name="patient"
                data-cy="patient"
                label={translate('tinyMedicRestApp.pregnancyCase.patient')}
                type="select"
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/pregnancy-case" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PregnancyCaseUpdate;
